import http from "../http";

const FlycoService = {
    getFlycoInfosService: async () => {
        const segments = await http.instance.get("/flyco/flycoinfos");
        return segments.data
    },

    getFlycoInfoService: async (payload) => {
        const segment = await http.instance.get("/flyco/flycoinfo/" + payload)
        return segment.data;
    },
    AddFlycoInfoService: async (form) => {
        const segment = await http.instance.post("/flyco/flycopost", form)
        return segment;
    }
};
export default FlycoService;
